import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AccountBalanceProcessPayloadSchema = z.object({
    balance: z.number().optional(),
});

export class AccountBalanceProcessPayload extends FromSchema(AccountBalanceProcessPayloadSchema) {
    balance?: number;
}
